import baseAPI from "@/api/base";
import {
  EditTemplateFolder,
  GetTemplateFolder,
  RegisterTemplateFolder,
} from "@/dtos/TemplateFolder.dto";
import {
  DELETE_TEMPLATE_FOLDER_URL,
  EDIT_TEMPLATE_FOLDER_URL,
  GET_TEMPLATE_FOLDER_URL,
  REGISTER_TEMPLATE_FOLDER_URL,
  TOGGLE_TEMPLATE_FOLDER_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class TemplateFolder {
  static getTemplateFolders = async (
    getTemplateFolder: GetTemplateFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_TEMPLATE_FOLDER_URL, {
      params: getTemplateFolder,
    });
    return response;
  };

  static registerTemplateFolder = async (
    registerTemplateFolder: RegisterTemplateFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_TEMPLATE_FOLDER_URL, {
      ...registerTemplateFolder,
    });
    return response;
  };

  static editTemplateFolder = async (
    editTemplateFolder: EditTemplateFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_TEMPLATE_FOLDER_URL, {
      ...editTemplateFolder,
    });
    return response;
  };

  static toggleTemplateFolderIsActive = async (
    editTemplateFolder: EditTemplateFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_TEMPLATE_FOLDER_IS_ACTIVE_URL, {
      ...editTemplateFolder,
    });
    return response;
  };

  static deleteTemplateFolder = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_TEMPLATE_FOLDER_URL}/${id}`);
    return response;
  };
}

export default TemplateFolder;
